import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { CommonModule, DatePipe } from '@angular/common';
import { MatSnackBarModule, MatFormFieldModule, MatInputModule, MatDialogModule, MatAutocompleteModule,
         MatTabsModule, 
         MatSelect,
         MatSelectModule} from '@angular/material';
import { MyDatePickerModule } from 'mydatepicker';
import { AdminRoutingModule } from './admin-routing.module';
import { AppCommonModule } from '../common/common.module';
import { UtilsModule} from '../utils/utils.module'
import { EmployeesComponent } from './employees/employees.component';
import { ProjectComponent } from './project/project.component';
import { TasksComponent } from './tasks/tasks.component';
import { AddTaskComponent } from './tasks/add-task/add-task.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AddEmployeeComponent } from './employees/add-employee/add-employee.component';
import { LokedTimesheetComponent } from './loked-timesheet/loked-timesheet.component';
import { PlanedActualComponent } from './planed-actual/planed-actual.component';
import { AddProjectComponent } from './project/add-project/add-project.component';
import { AuditLogComponent } from './audit-log/audit-log.component';
import { EditTimesheetComponent } from './edit-timesheet/edit-timesheet.component';
import { ReportsComponent } from './reports/reports.component';
import { DashboardService } from './dashboard/dashboard.service';
import { EmployeesService } from './employees/employees.service';
import { ProjectService } from './project/project.service';
import { TasksService } from './tasks/tasks.service';
import { AddTaskService } from './tasks/add-task/add-task.service';
import { AddEmployeeService } from './employees/add-employee/add-employee.service';
import { AddProjectService } from './project/add-project/add-project.service';
import { LockedTimesheetService } from './loked-timesheet/locked-timesheet.service';
import { PlannedActualService } from './planed-actual/planned-actual.service';
import { AdminGuard } from './admin.guard';
import { ReportsService } from './reports/reports.service';
import { EditTimesheetService } from './edit-timesheet/edit-timesheet.service';
import { NonComplianceListComponent } from './non-compliance-list/non-compliance-list.component';
import { NonComplianceListService } from './non-compliance-list/non-compliance-list.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxPaginationModule,
    MyDatePickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDialogModule,
    MatAutocompleteModule,
    AppCommonModule,
    AdminRoutingModule,
    UtilsModule,
    MatTabsModule
  ],
  exports: [MatSnackBarModule, MatAutocompleteModule],
  declarations: [
    ProjectComponent,
    TasksComponent,
    EmployeesComponent,
    DashboardComponent,
    AddProjectComponent,
    AddTaskComponent,
    AddEmployeeComponent,
    LokedTimesheetComponent,
    PlanedActualComponent,
    AuditLogComponent,
    ReportsComponent,
    EditTimesheetComponent,
    NonComplianceListComponent],
  providers: [
    DashboardService,
    EmployeesService,
    ProjectService,
    TasksService,
    AddTaskService,
    AddEmployeeService,
    DatePipe,
    AddProjectService,
    LockedTimesheetService,
    AdminGuard,
    ReportsService,
    EditTimesheetService,
    PlannedActualService,
    NonComplianceListService
  ]
})
export class AdminModule { }



// WEBPACK FOOTER //
// ./src/app/admin/admin.module.ts